module.exports = __webpack_public_path__ + "static/media/img9.b1b8f47e.jpg";